import { Modal, Button } from 'react-bootstrap';

export const ConfirmationModal = ({ 
  // Common props
  onShow, 
  onClose,
  onConfirm,
  title,
  confirmButtonText,
  cancelButtonText,
  
  // Optional styling
  modalStyle = { top: '150px' },
  titleClassName = 'mt-2 mb-5',
  
  // Optional callbacks and behavior
  onCancel = null // If null, defaults to onClose
}) => {
  
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm(true);
    handleClose();
  };
  
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onConfirm(false);
      handleClose();
    }
  };

  if (onShow) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }

  return (
    <div>
      <Modal
        className="clear-background"
        show={onShow}
        tabIndex="-1"
        onHide={handleClose}
        backdrop="static"
        backdropClassName="custom-backdrop-class"
        style={modalStyle}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className={titleClassName}><strong>{title}</strong></h5>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center align-items-center flex-column">
          <Button
            variant="primary"
            onClick={handleConfirm}
          >
            <strong>{confirmButtonText}</strong>
          </Button>
          {cancelButtonText && (
            <Button
              variant="link"
              className="text-danger"
              onClick={handleCancel}
            >
              {cancelButtonText}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}